import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

import { env } from "@env/environment";

@Component({
  selector: "app-dashboard",
  templateUrl: "./full-layout.component.html",
  providers: [],
})
export class FullLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private router: Router) { }

  portaleEnte = env.portaleEnte;
  currentYear = new Date().getFullYear();
  ente = env.ente;
  public disabled: boolean = false;
  public status: { isopen: boolean; } = { isopen: false };
  public versione: string = "";

  private numeroRiservati: number;

  public toggled(open: boolean): void {
    console.log("Dropdown is now: ", open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
    this.versione = env.buildNumber;
    this.currentYear = new Date().getFullYear();
  }

  ngAfterViewInit(): void { }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
  }

   // tslint:disable-next-line:member-ordering
    public footerLogos = [
    {
      href: "https://www.regione.toscana.it/",
      title: "Regione Toscana",
      alt: "Regione Toscana",
      src: "assets/img/rt.svg"
    },
    {
      href: "https://www.lavoro.gov.it/",
      title: "Ministero del Lavoro e delle Politiche Sociali",
      alt: "Ministero del Lavoro",
      src: "assets/img/ministero-lavoro.svg"
    },
    {
      href: "https://next-generation-eu.europa.eu/index_it",
      title: "Europe Next Generation",
      alt: "Europe Next Generation",
      src: "assets/img/europe-next-gen.svg"
    }
  ];

}
